import React, { useEffect, useState, useRef } from 'react'
import { PACS_URL } from '@custom/constant';
import { useTheme } from "../../ui/src/contextProviders"
import { ToolDelete } from '../../ui/assets/svgIcons/icon';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@custom/store/store';
import deletePreviewImage from '@custom/rtk-apis/report/deletePreviewImage';
import { Loader, SuccessModal } from '@ohif/ui';

const ImageViewer = ({ imageUrl }) => {

  // const [imageSrc, setImageSrc] = useState('');

  // function convertToWadoUrl(wadoRsUrl) {
  //   const baseUrl = `${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/wado?requestType=WADO`;

  //   const regex = /studies\/([^\/]+)\/series\/([^\/]+)\/instances\/([^\/]+)\/frames\/(\d+)/;
  //   const matches = wadoRsUrl.match(regex);

  //   if (matches) {
  //       const studyUID = matches[1];
  //       const seriesUID = matches[2];
  //       const objectUID = matches[3];
  //       const frameNumber = matches[4];

  //       const wadoUrl = `${baseUrl}&studyUID=${studyUID}&seriesUID=${seriesUID}&objectUID=${objectUID}&contentType=image/jpeg&frameNumber=${frameNumber}`;
  //       return wadoUrl;
  //   } else {
  //       console.error("Invalid WADO-RS URL format");
  //       return null;
  //   }
  // }



  // useEffect(() => {
  //     fetch(convertToWadoUrl(imageUrl))
  //         .then((response) => {
  //             if (response.ok) {
  //                 return response.blob();
  //             } else {
  //                 console.log('Failed to fetch image');
  //             }
  //         })
  //         .then((blob) => {
  //             const imageObjectURL = URL.createObjectURL(blob);
  //             setImageSrc(imageObjectURL);
  //         })
  //         .catch((error) => console.log('Error loading image:', error));

  // }, [imageUrl]);

  return (
    <div>
      <img src={imageUrl} alt="Report-Image" className='w-full h-auto object-cover shadow-lg' />
    </div>
  );
};

function ImagePreview({ setImgPreviewPg, images: propImages, reportDet, setReportDet }) {
  const [selectedImages, setSelectedImages] = useState([]);
  const dispatch = useDispatch<AppDispatch>()
  const [images, setImages] = useState(propImages);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isDarkMode = useTheme();

  useEffect(() => {
    setImages(propImages);
  }, [propImages]);

  const handleCheckboxChange = (image) => {
    setSelectedImages((prev) =>
      prev.includes(image)
        ? prev.filter((img) => img !== image)
        : [...prev, image]
    );
  };

  const handleDeleteImages = async () => {
    setIsLoading(true);
    try {
      const payload = {
        '_id': reportDet?._id,
        'imageUrls': selectedImages
      }
      await dispatch(deletePreviewImage(payload))

      const updatedImages = images.filter((image) => !selectedImages.includes(image));
      setImages(updatedImages);
      const updatedReportDet = {
        ...reportDet,
        images: updatedImages
      }
      setReportDet(updatedReportDet);
      setSelectedImages([]);
      setSuccessModalOpen(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error deleting images:', error);
    }
  };

  return (
    <div className='mt-4'>
      <section>
        <div className="flex flex-wrap justify-center gap-4">
          {images?.map((image, index) => (
            <div key={index} className="w-1/3 p-2 relative">
              {reportDet?.status != "Authorized" && <div style={{ left: '0.8rem', top: '0.5rem' }} className="absolute">
                <input
                  type="checkbox"
                  checked={selectedImages.includes(image)}
                  onChange={() => handleCheckboxChange(image)}
                />
              </div>}
              <ImageViewer imageUrl={image} />
            </div>
          ))}
        </div>
        {selectedImages.length > 0 &&
          <button
            onClick={handleDeleteImages}
            className='discard-btn'
          >
            <div style={{ width: '20px' }}>
              <img src={ToolDelete} alt="delete-icon" />
            </div>
          </button>
        }
      </section>
      <Loader isLoaderOpen={isLoading} />
      <SuccessModal
        isSuccessModalOpen={successModalOpen}
        title={"Image delete successfully"}
        handleCloseModal={() => setSuccessModalOpen(false)}
      />
    </div>
  )
}

export default ImagePreview
